export const CF_CORE_BASE_URL: Record<string, string> = {
  dev: 'https://7hns5p9og6.execute-api.eu-central-1.amazonaws.com',
  development: 'https://7hns5p9og6.execute-api.eu-central-1.amazonaws.com',
  int: 'https://lkeo3t4cvl.execute-api.eu-central-1.amazonaws.com',
  prod: 'https://c82zvcl7x1.execute-api.eu-central-1.amazonaws.com',
}
